import {ConnecttocrudService} from '../connecttocrud.service';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {MatPaginator, MatSnackBar} from '@angular/material';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ngxCsv} from 'ngx-csv/ngx-csv';
import {ConfService} from '../conf.service';
import {AppComponent} from '../app.component';
import {CsvService} from '../csv.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {FormControl} from '@angular/forms';
import {FilterPipe} from '../filter.pipe';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {HeadersComponent} from '../devex/headers/headers.component';
import {ManageEntitiesComponent} from '../manage-entities/manage-entities.component';

declare let $;

export interface Query {
    query: string;
}

@Component({
    selector: 'app-api1',
    templateUrl: './api.component.html',
    styleUrls: ['./api.component.css']
})
export class ApiComponent implements OnInit {
    items: any;
    filteredItems: any;
    languages: any;
    languageSelected = 'en';
    @Input() language: string;
    filterPipe = new FilterPipe();
    columns: string[] = [];
    columns1: string[] = [];
    navigate: any;
    searchText = '';
    itemLength: any;
    filterData: any[];
    settings = {text: 'Select attribute(s) to search instantly'};
    @Input() partner: string;
    @Input() account: string;
    @Input() entity: string;
    @Input() version: string;
    partnerKey: string;
    itemList: any[];
    options: any;
    userView = 'table';
    error = false;
    dataSource: any;
    dataModel: any;
    primaryKey = null;
    errorMessage: string;
    options1 = new JsonEditorOptions();
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild(ManageEntitiesComponent) manageEntities: ManageEntitiesComponent;
    selectedAttributeQuery: any;
    selectedOperatorQuery: any;
    querySearchText: any;
    apiByDefinition: any;
    query: any;
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    queries = [];
    queryColumns = [];
    querrParam = '';
    columnSelection = new FormControl();
    totalPages: any;
    tempTotalPages: any;
    currentPage: any;
    currentOffset = 0;
    limit = 20;
    table: any;
    collectionSize: any;
    tempCollectionSize: any;
    page = 1;
    currentPageDisplayed = 1;
    itemsPerPage = 20;
    selectedItemsPerPageIndex = 2;
    isAllRecordsFetched = false;
    recordLimit = 4000;
    isdbSearch: any;
    dbSearchParams: any;
    orig_entity: any;


    apiUrl: any;
    executor: any;
    executors: any;
    executor_name: any;
    executor_type: any;
    executor_version: any;
    authAttributes = {};
    authModel = {
        'authAttributes': this.authAttributes
    };
    selectedSearchOption = 'apiSearch';
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    prerequisites: any;
    requestBody: {};
    responseData: any;
    responseError: any;
    showPathParameters = true;
    formData = [];
    requestBodySelected = 'none';
    isPublished: any;
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}
    ];
    httpOperation = 'GET';
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    httpUrl: string;
    publishDataLoading = true;

    attributesList = '';


    constructor(public _service: ConnecttocrudService, private confPost: ConfService,
                private location: Location,
                private route: ActivatedRoute,
                private router: Router,
                private appComp: AppComponent,
                public snackBar: MatSnackBar,
                private csvService: CsvService,
                public platform: LeftpanelComponent, private manageEntitiesInstance: ManageEntitiesComponent) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /* this.editor.get() */);
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.items = [];
        this.appComp.currentPageTitle = 'Retrieve records for Data Access API';
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        if (this.platform.languages !== null && this.platform.languages !== undefined) {
            this.languages = this.platform.languages;
        } else {
            this.platform.getLanguages();
            this.languages = this.platform.languages;
        }
        this.route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                if (params.language != null) {
                    this.language = params.language;
                } else {
                    this.language = 'en';
                }
                this.languageSelected = this.language;
                this.partnerKey = localStorage.getItem('partnerKey');
                this.items = null;
                this.publishDataLoading = true;
                // this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(response => {
                //     if (response) {
                //         this.apiByDefinition = response;
                //         this.orig_entity = response;
                //         this.isPublished = this.orig_entity.published;
                //         this.publishDataLoading = false;
                //
                //     }
                // });
                this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, 'get' + this.entity, this.version).subscribe(response => {
                    if (response) {
                        this.executor = response;
                        this.executors = this.executor.executors;
                        this.apiUrl = this.executor.apiUrl;
                        this.httpOperation = this.executor.executor_method_type;
                        this.executor_name = this.executor.executor_name;
                        this.executor_version = this.executor.executor_version;
                        this.parameterData = this.executor.queryParams ? this.executor.queryParams : [];
                        this.pathParameter = this.executor.pathParams ? this.executor.pathParams : [];
                        this.headersData = this.executor.headers;
                    }
                    // this.businesslogic = true;
                });
                if (this.language === 'en') {
                    this.getitems('');
                } else {
                    this.getItemsByLanguage(this.language);
                }
                // this.getitems();
            });
        // $('.actions-crud').find('a:eq(2)').find('angular2csv').html('');
        // $('.actions-crud').find('a:eq(2)').find('angular2csv').append('<button>download</button>');
    }


    add(value, column): void {
        if (!this.queryColumns.includes(column) && !this.queries.includes(value)) {
            this.queries.push(value);
            this.queryColumns.push(column);
            if (this.querrParam !== '') {
                this.querrParam = this.querrParam + '&' + value;
            } else {
                this.querrParam = value;
            }
        } else {
            const temp = this.queryColumns.indexOf(column);
            this.querrParam = this.querrParam.replace(this.queries[temp], value);
            this.queries.splice(temp, 1);
            this.queryColumns.splice(temp, 1);
            this.queries.push(value);
            this.queryColumns.push(column);
        }
    }

    remove(value): void {
        const index = this.queries.indexOf(value);
        if (index >= 0) {
            this.queries.splice(index, 1);
            this.queryColumns.splice(index, 1);
            this.querrParam = this.querrParam.replace(value, '');
            this.getitems(this.querrParam);
        }
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        } else {
            this.filteredItems = this.filterPipe.transform(this.items, this.searchText, this.filterData);
            // this.tempTotalPages = this.totalPages;
            // this.tempCollectionSize = this.collectionSize;
            if (this.filteredItems && this.searchText !== '') {
                this.tempCollectionSize = this.filteredItems.length;
                this.tempTotalPages = Math.ceil(this.tempCollectionSize / this.itemsPerPage);
            } else {
                // this.totalPages = this.tempTotalPages;
                // this.collectionSize = this.tempCollectionSize;
            }
        }
    }

    download() {
        // $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
        this.csvService.downloadFile(this.items, 'csv', this.columns);


    }

    executeQuery() {
        if (this.selectedAttributeQuery && this.selectedOperatorQuery && this.querySearchText) {
            const recordType = this.typeOfval(this.items[0][this.selectedAttributeQuery]);
            switch (recordType) {
                case 'number':
                    switch (this.selectedOperatorQuery) {
                        case '<=':
                            const temp1 = this.selectedAttributeQuery + '.lte=' + this.querySearchText;
                            this.add(temp1, this.selectedAttributeQuery);
                            break;
                        case '>=':
                            const temp2 = this.selectedAttributeQuery + '.gte=' + this.querySearchText;
                            this.add(temp2, this.selectedAttributeQuery);
                            break;
                        case '>':
                            const temp3 = this.selectedAttributeQuery + '.gt=' + this.querySearchText;
                            this.add(temp3, this.selectedAttributeQuery);
                            break;
                        case '<':
                            const temp4 = this.selectedAttributeQuery + '.lt=' + this.querySearchText;
                            this.add(temp4, this.selectedAttributeQuery);
                            break;
                        case '==':
                            const temp5 = this.selectedAttributeQuery + '.eq=' + this.querySearchText;
                            this.add(temp5, this.selectedAttributeQuery);
                            break;
                        /*case '!=':
                            const temp6=this.selectedAttributeQuery+'.lte='+this.queryText;
                            this.add(temp6);
                            break;*/
                        default:
                            this.platform.openSnackBar('Invalid operator for ' + this.selectedAttributeQuery, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            break;
                    }
                    break;
                case 'string':
                    switch (this.selectedOperatorQuery) {
                        case '==':
                            const temp1 = this.selectedAttributeQuery + '.eq=' + this.querySearchText;
                            this.add(temp1, this.selectedAttributeQuery);
                            break;
                        /*case '!=':
                            const temp2=this.selectedAttributeQuery+'.lte='+this.queryText;
                            this.add(temp2);
                            break;*/
                        default:
                            this.platform.openSnackBar('Invalid Operator for ' + this.selectedAttributeQuery, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            break;
                    }
                    break;
                default:
                    this.platform.openSnackBar('Invalid Query ', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    break;
            }


            this.selectedAttributeQuery = '';
            this.selectedOperatorQuery = '';
            this.querySearchText = '';
        } else {
            this.query = {
                'attribute': '',
                'operator': '',
                'text': '',
                'type': ''
            };
        }
        if (this.columnSelection.value && this.columnSelection.value.length > 0) {
            const temp = 'fields=' + this.columnSelection.value.toString();
            this.add(temp, 'fields');
            this.columnSelection.reset();
        }

    }

    getItemsByLanguage(language) {
        this.error = false;
        this._service.getItemsByLanguage(this.version, this.partner, this.account, this.entity, language).subscribe(
            items => {
                this.items = items;
                this.itemLength = this.items.length;
                for (const item of this.items) {
                    this.columns = [];
                    for (const itemval in item) {
                        this.columns.push(itemval);
                    }
                }
                this.itemList = [];
                for (let t = 0; t < this.columns.length; t++) {
                    const tempObj = {};
                    tempObj['id'] = t;
                    tempObj['itemName'] = this.columns[t];
                    this.itemList.push(tempObj);
                }
                this.options = {
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalseparator: '.',
                    headers: this.columns,
                    showTitle: false,
                    useBom: true,
                    noDownload: false,
                    nullToEmptyString: true,
                    removeNewLines: false,
                    keys: []
                };
            },
            error => {
                this.error = true;
                this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '';
            }
        );

    }

    // getLanguages() {
    //     this.confPost.getLanguages().subscribe(
    //         items => {
    //             this.languages = items;
    //         },
    //         error => {
    //             this.platform.openSnackBar('Error while getting list of languages: ' + error.error.message, 'Error', {
    //                 duration: 5000,
    //                 verticalPosition: 'top',
    //                 horizontalPosition: 'center'
    //             });
    //         }
    //     );
    // }

    manipulateItems(items, idFound) {
        this.items = items[0]['data'];
        this.currentPage = items[0]['_pages']['current'];
        this.page = 1;
        this.currentPageDisplayed = 1;
        this.totalPages = items[0]['_pages']['total'];
        this.collectionSize = items[0]['_pages']['totalRows'];
        this.currentOffset = 0;
        this.columns = Object.keys(this.items[0]);
        const indexOfIdColumn = this.columns.indexOf('_id');
        if (indexOfIdColumn !== -1) {
            this.columns.splice(indexOfIdColumn, 1);
        }

        this.itemList = this.columns.map((columnName, index) => {
            return {
                id: index,
                itemName: columnName
            };
        });
        this.columns1 = JSON.parse(JSON.stringify(this.columns));
        if (this.apiByDefinition && this.apiByDefinition !== undefined && this.apiByDefinition !== null) {
            for (let i = 0; i < this.apiByDefinition.attributes.length; i++) {
                for (let j = 0; j < this.columns.length; j++) {
                    if (this.apiByDefinition['attributes'][i]['attributeName'] === this.columns[j]) {
                        if (this.apiByDefinition['attributes'][i]['displayName'] !== null && this.apiByDefinition['attributes'][i]['displayName'] !== '') {
                            this.columns1[j] = this.apiByDefinition['attributes'][i]['displayName'];
                        }
                    }
                }
            }
        }
        this.options = {
            fieldSeparator: ',',
            quoteStrings: '',
            decimalseparator: '.',
            headers: this.columns,
            showTitle: false,
            useBom: true,
            noDownload: false,
            nullToEmptyString: true,
            removeNewLines: false,
            keys: []
        };
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
    }

    getitems(params, fetchAll = false) {
        this.error = false;
        // this.collectionSize = 0;
        this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(data => {
            this.apiByDefinition = data;
            this.orig_entity = data;
            this.isPublished = this.orig_entity.published;
            this.publishDataLoading = false;
            const idFound = false;
            this.currentOffset = 0;
            this.isAllRecordsFetched = false;
            this.isdbSearch = false;
            this.dbSearchParams = params;
            this.attributesList = '';
            if (this.orig_entity.hasOwnProperty('attributes')) {
                for (let i = 0; i < this.orig_entity['attributes'].length; i++) {
                    const attribute = this.orig_entity['attributes'][i];
                    if (attribute) {
                        this.attributesList = this.attributesList.concat(attribute['attributeName']);
                        if (i !== this.orig_entity['attributes'].length - 1) {
                            this.attributesList = this.attributesList.concat(',');
                        }
                    }
                }
            }
            if (params === '') {
                // this._service.getItems(this.version, this.partner, this.account, this.entity, true).subscribe(
                if (fetchAll) {
                    if (this.collectionSize > 2000) {
                        this.platform.openSnackBar('Total records exceeds 2000. However, you can still view data by navigating through pages.', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else {
                        this.currentOffset = 0;
                        this.limit = this.collectionSize;
                    }
                } else {
                    this.limit = 20;
                    this.collectionSize = 0;
                }
                this._service.getPaginatedData(this.version, this.partner, this.account, this.entity, this.currentOffset, this.limit, this.attributesList).subscribe(
                    items => {
                        let temp: any;
                        temp = items;
                        if (temp && temp.length) {
                            this.manipulateItems(items, idFound);
                            if (this.filterData && this.filterData.length) {
                                this.filterData = [];
                            }
                            this.searchText = '';
                            this.queries = [];
                            this.selectedAttributeQuery = '';
                            this.selectedOperatorQuery = '';
                            this.querySearchText = '';
                            this.requestBody = {};
                            this.parameterData = [];
                            if (fetchAll) {
                                if (this.collectionSize < 2000) {
                                    this.platform.openSnackBar('All records fetched successfully', 'Success', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    this.isAllRecordsFetched = true;
                                }
                            }
                        } else {
                            this.items = [];
                        }

                    },
                    error => {
                        this.error = true;
                        this.router.navigateByUrl('/controlplane');
                        this.platform.handleErrorGracefully(error, 'Error while fetching partner entity. Please try again after sometime.');
                        this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '';
                    }
                );
            } else {
                this.isdbSearch = true;
                this.dbSearchParams = params;
                params = params + '&limit=2000';
                this._service.getItemsWithParams(this.version, this.partner, this.account, this.entity, params).subscribe(
                    items => {
                        let temp: any;
                        temp = items;
                        if (temp.length) {
                            this.isAllRecordsFetched = true;
                            this.manipulateItems(items, idFound);
                        } else {
                            this.items = [];
                            this.collectionSize = 0;
                        }
                    },
                    error => {
                        this.error = true;
                        this.router.navigateByUrl('/controlplane');
                        this.platform.handleErrorGracefully(error, 'Error while fetching partner entity. Please try again after sometime.');
                        this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '';
                    }
                );
            }
            this.confPost.getPartnerEntity(this.account, this.entity, this.partner).subscribe(items => {
                this.dataSource = items[0].attributes;
                this.getDataModel();
            }, error => {
                this.router.navigateByUrl('/controlplane');
                this.platform.handleErrorGracefully(error, 'Error while fetching partner entity. Please try again after sometime.');
            });
        }, error => {
            this.router.navigateByUrl('/controlplane');
            this.platform.handleErrorGracefully(error, 'Error while fetching entity. Please try again after sometime.');
        });

    }

    // lastPage(pageStatus) {
    //     if (pageStatus.rowsOnPage * pageStatus.activePage >= this.items.length) {
    //         if (this.currentPage !== this.totalPages && this.totalPages !== 1) {
    //             this.currentOffset = this.currentOffset + 1000;
    //             this.getPaginatedData();
    //         }
    //     }
    //
    // }

    lastPage() {
        if (this.searchText === '' && !this.isAllRecordsFetched) {
            this.currentOffset = (this.page - 1) * this.itemsPerPage;
            this.limit = this.itemsPerPage;
            this.getPaginatedData();
            this.currentPageDisplayed = 1;
        } else {
            this.currentPageDisplayed = this.page;
        }
        if (this.isdbSearch) {
            this.currentPageDisplayed = this.page - Math.ceil((this.currentOffset / this.itemsPerPage));
            const cPage = (this.page - 1) * this.itemsPerPage;
            if (!(this.page >= Math.ceil((this.currentOffset / this.itemsPerPage)) && this.page <= Math.ceil(((this.currentOffset + this.items.length) / this.itemsPerPage)))) {
                this.currentOffset = (this.page - 1) * this.itemsPerPage;
                this.getPaginatedDataWithParams();
                this.currentPageDisplayed = 1;
            }
        }
    }

    getPageSymbol(current: number) {
        return [10, 20, 40, 60, 100][current - 1];
    }

    setItemsPerPage() {
        switch (this.selectedItemsPerPageIndex) {
            case 1:
                this.itemsPerPage = 10;
                break;
            case 2:
                this.itemsPerPage = 20;
                break;
            case 3:
                this.itemsPerPage = 40;
                break;
            case 4:
                this.itemsPerPage = 60;
                break;
            case 5:
                this.itemsPerPage = 100;
                break;
            default:
                this.itemsPerPage = 20;
        }

        if (this.items && this.items.length && this.searchText === '' && !this.isAllRecordsFetched) {
            this.lastPage();
        }
    }

    getPaginatedData() {
        this._service.getPaginatedData(this.version, this.partner, this.account, this.entity, this.currentOffset, this.limit, this.attributesList).subscribe(response => {
            if (response) {
                let temp: any;
                temp = response;
                if (temp.length) {
                    this.items = response[0]['data']; // this.items.concat(temp);
                    this.currentPage = response[0]['_pages']['current'];
                    this.totalPages = response[0]['_pages']['total'];
                }
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching the records. Please try again after sometime.');
            // this.platform.openSnackBar('Error while deleting this record' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    getPaginatedDataWithParams() {
        const params = this.dbSearchParams + '&pagination=true&offset=' + this.currentOffset + '&limit=2000';
        this._service.getItemsWithParams(this.version, this.partner, this.account, this.entity, params).subscribe(response => {
            if (response) {
                let temp: any;
                temp = response;
                if (temp.length) {
                    this.items = response[0]['data']; // this.items.concat(temp);
                    this.currentPage = response[0]['_pages']['current'];
                    this.totalPages = response[0]['_pages']['total'];
                }
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching the records. Please try again after sometime.');
            // this.platform.openSnackBar('Error while deleting this record' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    getCSV(data) {
        alert('coming');
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: true,
            title: this.entity,
            useBom: true,
            noDownload: true,
            headers: this.columns,
            nullToEmptyString: true,
        };
        return new ngxCsv(data, 'my Report');
    }

    deleteRecord(version, id: string, event) {
        if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
            this._service.deleteItem(id, version, this.partner, this.account, this.entity).subscribe(
                agents => {
                    this.platform.openSnackBar('Deleted successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    const itemDuplicate = this.items;
                    const deleteditem = itemDuplicate.findIndex(p => p && p.id === id);
                    this.items.splice(deleteditem, 1);
                    // delete this.items[deleteditem];
                    // this.removeItemFromUI(event);
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while deleting this record. Please try again after sometime.');
                    // this.platform.openSnackBar('Error while deleting this record' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                });
        }
    }

    removeItemFromUI(event) {
        $(event.target).closest('td').parent('tr').remove();
    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }

    getDataModel() {
        const that = this;
        this.dataSource.forEach((data) => {
            if (data.type === 'ObjectId' && this.primaryKey == null) {
                this.primaryKey = 'id';
            } else if (data.attributeType === 'Primary' && this.primaryKey == null) {
                this.primaryKey = data.attributeName;
            }
        });
    }

    displaySearchType(event, changeChevron) {
        if (changeChevron) {
            $(event.target).toggleClass('fa-chevron-up fa-chevron-down');
        }
        const apiId = '#apiSearch';
        const dbId = '#dbSearch';
        if (this.selectedSearchOption === 'apiSearch') {
            if (!changeChevron) {
                if($(event).hasClass('fa-chevron-down')){
                    $(event).toggleClass('fa-chevron-up fa-chevron-down');
                }
                $(apiId).hasClass('in') ? $(apiId).removeClass('in') : $(apiId).addClass('in');
                $(dbId).removeClass('in');
            } else if (changeChevron) {
                $(apiId).hasClass('in') ? $(apiId).removeClass('in') : $(apiId).addClass('in');
                $(dbId).removeClass('in');
            }

        } else if (this.selectedSearchOption === 'databaseSearch') {
            if (!changeChevron) {
                if($(event).hasClass('fa-chevron-down')){
                    $(event).toggleClass('fa-chevron-up fa-chevron-down');
                }
                $(dbId).hasClass('in') ? $(dbId).removeClass('in') : $(dbId).addClass('in');
                $(apiId).removeClass('in');
            } else if (changeChevron) {
                $(dbId).hasClass('in') ? $(dbId).removeClass('in') : $(dbId).addClass('in');
                $(apiId).removeClass('in');
            }
        }
    }

    async executeApi() {
        // this.pathParameter.push({'pagination': 'true'});
        let queryParams = [];
        queryParams.push({annotation: 'RequestParam', key: 'pagination', value: 'true'});
        queryParams.push({annotation: 'RequestParam', key: 'offset', value: '0'});
        queryParams.push({annotation: 'RequestParam', key: 'limit', value: '2000'});
        queryParams = queryParams.concat(this.parameterData);
        const apiUrl = this.apiUrl + '?pagination=true&offset=0limit=10';
        const payload = {
            'executor_name': this.executor_name,
            'executor_type': 'API',
            'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.apiUrl,
            'dataroot': null,
            'queryParams': queryParams,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            'executors': this.executors,
            'prerequisites': null
        };
        payload['authModel'] = this.headerChild.authModel1.getAuthModel();
        // if (payload['authModel']['authType'] === 'no_auth') {
        //     delete payload['authModel']['authType'];
        // }
        this._service.executeApi(payload).subscribe(response => {
            if (response) {
                const responseItems = response;
                this.isAllRecordsFetched = true;
                this.isdbSearch = true;
                this.manipulateItems(JSON.parse(responseItems.body['body']), false);
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching the records. Please try again after sometime.');
        });
    }

    async openPublishConfirmationDialog(event, partner, account, entityname, version, published) {
        const result = await this.manageEntitiesInstance.openPublishConfirmationDialog(event, partner, account, entityname, version, published);
        if (result && result === 'success') {
            this.isPublished = true;
        }
    }
}
